import { readable } from "svelte/store";
import { State } from "../Model/State";
const followModeTemporarilyDisabled = new State(false);
const followModeTemporarilyDisabledReadable = readable(false, set => followModeTemporarilyDisabled.subscribe(set));
export const followMode = new State(loadFollowModeStatus());
export { followModeTemporarilyDisabledReadable as followModeTemporarilyDisabled, };
followMode.subscribe(state => {
    localStorage.setItem('follow_mode', state ? '1' : '0');
});
export function disableFollowModeTemporarily(value) {
    if (followModeTemporarilyDisabled.value === value) {
        return;
    }
    followModeTemporarilyDisabled.set(value);
}
export function enableFollowMode() {
    if (followMode.value) {
        return;
    }
    followMode.set(true);
}
export function disableFollowMode() {
    if (!followMode.value) {
        return;
    }
    followMode.set(false);
}
export function isFollowModeEnabled() {
    return followMode.value;
}
export function toggleFollowMode() {
    followMode.set(!followMode.value);
}
function loadFollowModeStatus() {
    const savedMode = localStorage.getItem('follow_mode');
    return savedMode === null ? true : savedMode === '1';
}
